import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import TextComponent from "../TextComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import CartComponent from "../CartComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import ButtonComponent from "../ButtonComponent";
import Checkout from "../Checkout/Checkout";
import FooterComponent from "../FooterComponent";
import EventRoundTripComponent from "../Events/EventRoundTripComponent";
import EventAdditionalItemsComponent from "../Events/EventAdditionalItemsComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  text: TextComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  cart: CartComponent,
  inner_section: InnerSectionComponent,
  Button: ButtonComponent,
  Checkout: Checkout,
  footer: FooterComponent,
  eventRoundTripComponent: EventRoundTripComponent,
  eventAdditionalItemsComponent: EventAdditionalItemsComponent,
};
